import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message/MessageSlice';
import SurchargeRuleService from '../../../service/settings/SurchargeRuleService';

export const fetchPaymentMethods = createAsyncThunk('SurchargeRuleSlice/fetchPaymentMethods', async (_, thunkAPI) => {
  try {
    const response = await SurchargeRuleService.getPaymentMethods();
    return { paymentMethods: response.data.data || response.data };
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue();
  }
});

export const fetchPaymentGateways = createAsyncThunk('SurchargeRuleSlice/fetchPaymentGateways', async (_, thunkAPI) => {
  try {
    const response = await SurchargeRuleService.getPaymentGateways();
    return { paymentGateways: response.data.data || response.data };
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue();
  }
});

export const fetchSurchargeRules = createAsyncThunk('SurchargeRuleSlice/fetchSurchargeRules', async (payload, thunkAPI) => {
  try {
    const response = await SurchargeRuleService.getSurchargeRules(payload || {});
    const rules = response.data.data?.data || response.data.data || response.data || [];
    return { rulesList: rules };
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue();
  }
});

export const saveSurchargeRule = createAsyncThunk('SurchargeRuleSlice/saveSurchargeRule', async (data, thunkAPI) => {
  try {
    const response = await SurchargeRuleService.saveSurchargeRule(data);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message);
  }
});

export const deleteSurchargeRule = createAsyncThunk('SurchargeRuleSlice/deleteSurchargeRule', async (id, thunkAPI) => {
  try {
    const response = await SurchargeRuleService.deleteSurchargeRule(id);
    return response.data;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message);
  }
});

const SurchargeRuleSlice = createSlice({
  name: 'SurchargeRuleSlice',
  initialState: {
    rulesList: [],
    paymentMethods: [],
    paymentGateways: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSurchargeRules.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSurchargeRules.fulfilled, (state, action) => {
        state.loading = false;
        state.rulesList = action.payload.rulesList;
      })
      .addCase(fetchSurchargeRules.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message;
        state.rulesList = [];
      })
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.paymentMethods = action.payload.paymentMethods;
      })
      .addCase(fetchPaymentGateways.fulfilled, (state, action) => {
        state.paymentGateways = action.payload.paymentGateways;
      });
  },
});

export default SurchargeRuleSlice.reducer;
